import React, { useState, } from 'react';
import Axios from 'axios';
import EntityManagement from './entityManagement';
import { Entity } from './entityForm';
import { mergeStateValue, deepClone } from '../utilities/generic';
import { FilterSelections } from '../reducers/filterSelections';
import { Groups } from '../reducers/authenticated/authenticatedReducer';
import { useTranslation } from "react-i18next";

function CountryManagement(props: Readonly<{
    filterSelections: FilterSelections,
    groups: Groups,
    onDataUpdated: () => void,
}>) {

    const [countries, setCountries] = useState([] as Entity[]);
    const [currentCountry, setCurrentCountry] = useState<Entity>({ id: 0, name: '' });

    const restPath = '/v10/countries/';

    const { t } = useTranslation();

    function fetchData() {
        Axios.get('/v10/countries').then(response => setCountries(response.data.result));
    }

    async function startEditing(id) {
        if (id === undefined) {
            setCurrentCountry({ id: 0, name: '' });
        } else {
            const country = countries.find(e => e.id === id);
            if (!country) {
                throw new Error('Internal error');
            }
            setCurrentCountry(deepClone(country));
        }
    }

    function changeValue(name, value) {
        mergeStateValue(setCurrentCountry, name, value);
    }

    function validate() {
        return (currentCountry?.name?.trim() === "") ? t("Please specify a country name") : "";
    }

    function getSanitizedEditingValues() {
        return { name: currentCountry?.name?.trim() };
    }

    return (
        <EntityManagement
            groups={props.groups}
            filterSelections={props.filterSelections}
            onDataUpdated={props.onDataUpdated}

            restPath={restPath}
            fetchData={fetchData}

            editor={{
                edit: startEditing,
                getSanitizedValues: getSanitizedEditingValues,
                set: changeValue,
                validate: validate,
                entityName: 'currentCountry'
            }}

            texts={{
                localizedAddNewText: t('Add new country'),
                confirmDelete: t('Are you sure you want to delete the country?'),
                errors: {
                    generic: t("Country couldn't be saved! Please try again or contact administrator!"),
                    alreadyExists: t("A Country with that name already exists"),
                    deleteInUse: t("Country is in use and cannot be deleted"),
                    deleteGeneric: t("Country couldn't be deleted! Please try again or contact administrator!")
                }
            }}

            entities={{ countries, currentCountry }}
            entityName='countries'

            tableHeaders={[{ localizedText: t('Country'), name: 'name', sortable: true },
            { localizedText: t('Edit'), type: 'edit' },
            { localizedText: t('Delete'), type: 'delete' }]}

            formFields={[{ label: t('Country Name'), name: 'name', placeholder: t('Enter a country name'), maxLength: 255 }]}
        />
    );
}

export default CountryManagement;
